export default __webpack_public_path__ + "static/media/15.bf116b51.jpg";